import React from 'react'
import EnquireForm from './EnquireForm';
import Location from './Location';

export default function ContactUs() {
  return (
    <>
      <EnquireForm/>
      <Location/>
    </>
  )
}
